import { defineComponent as _defineComponent } from 'vue'
import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  HeadingDisplay,
  ButtonBoxDecide
} from '@warrenbrasil/nebraska-web';
import { CloseButton } from '@/modules/common/components/buttons';
import { FadeTransition } from '@/modules/common/components/FadeTransition';
import { onMounted, ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';
import { getShelfCatalogHome } from '@/modules/transaction/services/investment';
import { IShelfButton } from '@/modules/transaction/services/investment/types';
import Catalog from '@/modules/catalog/views/Catalog/Catalog.vue';
import WealthInvest from '@/modules/wealth/views/WealthInvest/WealthInvest.vue';
import { buttonRouteMapper } from './button-url-mapper';
import {
  trackNewInvestment,
  trackNewInvestmentClick,
  trackMyPortfolio,
  trackWealthInvestment
} from './track-events';
import { useCatalogStore } from '@/modules/catalog/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Investment',
  setup(__props) {

const showNavbar = ref(true);
const isLoading = ref(false);
const hasError = ref(false);
const router = useRouter();
const route = useRoute();
const products = ref<IShelfButton[]>([]);
const cameFrom = ref((route.query.cameFrom as string) || 'home');

async function fetchShelfCatalogHome() {
  try {
    isLoading.value = true;
    hasError.value = false;

    const response = await getShelfCatalogHome();
    products.value =
      response.buttons.filter(
        button => buttonRouteMapper[button.productType]
      ) || [];
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

const showTabsAsWealthInvestment = computed(() => {
  return cameFrom.value === 'wealth';
});

function routeInvestmentGuard() {
  useCatalogStore().setFromUserFlow('investment', cameFrom.value);
}

function goToProduct(productType: string) {
  trackNewInvestmentClick(productType);
  routeInvestmentGuard();

  router.push({
    path: buttonRouteMapper[productType]
  });
}

onMounted(() => {
  trackNewInvestment();
  fetchShelfCatalogHome();
});

const backStep = () => {
  useCatalogStore().setFromUserFlow('', '');
  router.push({ path: `/${cameFrom.value}` });
};

function setTabs(tab: number) {
  switch (tab) {
    case 0:
      if (showTabsAsWealthInvestment.value) {
        trackWealthInvestment();
      } else {
        trackNewInvestment();
      }
      break;
    case 1:
      trackMyPortfolio();
      break;
  }
}

return { __sfc: true,showNavbar, isLoading, hasError, router, route, products, cameFrom, fetchShelfCatalogHome, showTabsAsWealthInvestment, routeInvestmentGuard, goToProduct, backStep, setTabs, NavBar, LoaderIndicator, HelperViewStatus, Tabs, TabList, Tab, TabPanels, TabPanel, HeadingDisplay, ButtonBoxDecide, CloseButton, FadeTransition, Catalog, WealthInvest }
}

})